import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { PapiDeviation } from '@wix/da-types-papi';
import { Url, USER_PROFILE_POSTS_SUB_PATHS } from '@wix/da-url';
import { MeasuredSlider as Slider } from '@wix/da-shared-react/pkg/Slider';
import SwipeSlider from '@wix/da-shared-react/pkg/SwipeSlider';
import WidgetBox, {
  Props as WidgetBoxProps,
} from '../../../../UserWidgets/_partials/WidgetBox';
import StandardThumb from '@wix/da-shared-react/pkg/DeviationViews/Thumb/Standard';
import DuperbrowseContext from '../../../../../contexts/DuperbrowseContext';
import EmptyState from '../../_partials/EmptyState';
import PostEditableItem from '../../../../UserWidgets/_partials/PostEditableItem';
import { ModalType } from '@wix/da-shared-react/pkg/Modals/redux/types';
import { withMobileContext } from '@wix/da-shared-react/pkg/Context/MobileContext';

import s from '../PostsAll.scss';

export interface Props {
  streamId: string;
  moduleId: number;
  polls: PapiDeviation[];
  total: number;
  ownerUsername: string;
  isMobile?: boolean;
}

export class PollSlider extends React.Component<
  Props & WidgetBoxProps & WithTranslation
> {
  render() {
    const {
      t,
      streamId,
      widgetMoveUp,
      widgetMoveDown,
      widgetRemove,
      moduleId,
      polls,
      total,
      ownerUsername,
      isMobile,
    } = this.props;
    const isEmpty = !polls.length;
    return (
      <WidgetBox
        header={t!('common.polls_plural')}
        count={total}
        moduleId={moduleId}
        isEmpty={isEmpty}
        hasMore={!isEmpty} // until we implement inner slider overflow recognition
        emptyView={
          <EmptyState
            className={s['empty-state-poll']}
            view="wide"
            postType="poll"
            CTAButtonModalType={ModalType.POLL_EDIT}
          />
        }
        seeAllUrl={Url.userPostsPath({
          username: ownerUsername,
          subPath: USER_PROFILE_POSTS_SUB_PATHS.POLLS,
        })}
        widgetMoveUp={widgetMoveUp}
        widgetMoveDown={widgetMoveDown}
        widgetRemove={widgetRemove}
      >
        <DuperbrowseContext
          streamId={streamId}
          deviations={polls}
          parent={{ title: ownerUsername }}
        >
          {isMobile ? (
            <SwipeSlider>
              {polls.map(poll => (
                <PostEditableItem key={poll.deviationId} item={poll}>
                  <StandardThumb deviation={poll} height={343} />
                </PostEditableItem>
              ))}
            </SwipeSlider>
          ) : (
            <Slider
              renderSliderItems={elementSize =>
                polls.map(poll => (
                  <PostEditableItem key={poll.deviationId} item={poll}>
                    <StandardThumb
                      deviation={poll}
                      width={elementSize.width}
                      height={elementSize.height}
                    />
                  </PostEditableItem>
                ))
              }
            />
          )}
        </DuperbrowseContext>
      </WidgetBox>
    );
  }
}

export default withMobileContext(withTranslation()(PollSlider));
